module.exports = __webpack_public_path__ + "img/self-f.5c80c937.png";